// extracted by mini-css-extract-plugin
export var breadcrumb = "_12-0";
export var breadcrumbArrow = "_12-1";